<svg
    matTooltip="{{ getProgress() }}%"
    matTooltipPosition="above"
    width="16"
    height="16"
    viewBox="0 0 16 16"
>
    <circle class="bg-circle" cx="8" cy="8" r="8"></circle>
    <path class="pi-color" [attr.d]="getPath()"></path>
</svg>
